import { create } from "zustand";
import { persist } from "zustand/middleware";
import { customStorage } from "../utils";

const useAlertStore = create()(
  persist(
    (set) => ({
      message: "",
      title: "",
      type: "",
      status: false,
      notification: { title: "", body: "", titleArabic: "", bodyArabic: "" },

      // createAlert function to update alert state
      createAlert: ({ title, notification, message, type, status }) =>
        set({
          title: title,
          notification: notification,
          message: message,
          type: type,
          status: status,
        }),
    }),
    {
      name: "alert-storage", // The name of the storage for persistence
      storage: customStorage, // Using localStorage for persistence
    }
  )
);

export default useAlertStore;
